import React from 'react'
import {IconButton, TableCell, TableRow, withStyles} from '@material-ui/core';
import styles from '../styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import {DeleteForever as DeleteRowIcon} from '@material-ui/icons';
import {roundCapacityValues} from '../../../../../services/util/helperFuncs';

function InsertBodyEdit(props) {

  const {classes, className, product, deleteProduct, t} = props;

  return (
    <TableRow className={className}>
      <TableCell colSpan={2}>{product.description}</TableCell>
      <TableCell>{roundCapacityValues(product.amount)}</TableCell>
      <TableCell>{roundCapacityValues(product.weight)}</TableCell>
      <TableCell>
        <IconButton
          className={classes.buttonRight}
          color="primary"
          onClick={() => deleteProduct(product)}
          title={t('delete')}
        >
          <DeleteRowIcon className={classes.redIcon}/>
        </IconButton>
      </TableCell>
    </TableRow>
  );
}


InsertBodyEdit.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  deleteProduct: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default compose(withStyles(styles), withTranslation())(InsertBodyEdit);
